import { Link } from 'react-router-dom'

import { useDocumentTitle } from '../useDocumentTitle.js'

// The handoff lists the 404 under "not yet designed". This uses the explainer
// page type's title block rather than inventing a layout for it — which is the
// point of having a page type.
//
// Voice: a 404 is somebody's link not working, so it says that and offers the
// way back, with no joke in it.

export default function NotFound() {
  useDocumentTitle('Page not found')

  return (
    <article className="d2d-page">
      <header className="d2d-titleblock">
        <h1 className="d2d-titleblock__headline">Page not found</h1>
        <p className="d2d-titleblock__lede">There is nothing at this address.</p>
        <hr className="d2d-rule" />
      </header>
      <p>
        <Link to="/">Go to the start</Link>
      </p>
    </article>
  )
}
